<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-input
            v-model="searchTitle"
            class="handle-input mr10"
            placeholder="请输入内容"
          ></el-input>
          <el-select v-model="searchPlatform_type" class="handle-select mr10">
            <el-option
              v-for="(child, index) in platform_type"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
          <el-select v-model="searchEnable" class="handle-select mr10">
            <el-option
              v-for="(child, index) in enable"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
          <el-date-picker
            class="handle-date mr10"
            v-model="searchDate"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="handle-add"
            @click="searchBtn"
            >搜索</el-button
          >
        </div>
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add"
          @click="addEdit"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + page_index }}</span>
          </template>
        </el-table-column>
        <el-table-column label="广告图片" align="center" width="200">
          <template slot-scope="scope">
            <el-image
              class="table-td-thumb"
              :src="scope.row.img_url"
              :preview-src-list="[scope.row.img_url]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column prop="img_url" label="图片路径" align="center">
          <template slot-scope="scope">
            {{ scope.row.img_url }}
          </template>
        </el-table-column>
        <el-table-column
          prop="link_url"
          label="跳转地址"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="duration"
          label="广告显示时间/s"
          align="center"
        ></el-table-column>
        <el-table-column label="广告生效时间" align="center" width="100">
          <template slot-scope="scope">
            {{ formatDate(scope.row.start_time) }}
          </template>
        </el-table-column>
        <el-table-column label="广告截止时间" align="center" width="100">
          <template slot-scope="scope">
            {{ formatDate(scope.row.end_time) }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="100">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="启用状态" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.enable == 1">已启用</el-tag>
            <el-tag type="danger" v-else>未启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="所属板块" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.platform_type == 0">全部</span>
            <span v-if="scope.row.platform_type == 1">家庭中医馆</span>
            <span v-if="scope.row.platform_type == 2">中医智库</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.enable"
              type="text"
              icon="el-icon-edit"
              @click="enableEdit(scope.row)"
              >不启用</el-button
            >
            <el-button
              v-else
              type="text"
              icon="el-icon-edit"
              @click="enableEdit(scope.row)"
              >启用</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="标题：" prop="title">
          <el-input v-model="form.title" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="platform_type">
          <el-select v-model="form.platform_type" class="handle-select mr10">
            <el-option
              v-for="(child, index) in platform_type"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转地址：" prop="link_url">
          <el-input v-model="form.link_url" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="广告图片：" prop="img_path">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.img_path"
              :src="form.img_path"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!form.img_path && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
        <el-form-item label="广告显示时间：" prop="duration">
          <el-input v-model="form.duration"></el-input>
        </el-form-item>
        <el-form-item label="广告生效时间：" prop="date">
          <el-date-picker
            class="handle-date mr10"
            v-model="form.date"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="goDate()"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/hemeraApiConfig";
import http2 from "../../../api/uploadApiConfig";
import md5 from "js-md5";
export default {
  name: "Advertisement",
  data() {
    return {
      searchTitle: "",
      searchDate: [],
      searchPlatform_type: 0,
      searchEnable: 2,
      start_time: "",
      end_time: "",
      date: [],
      platform_type: [
        { label: "全部", value: 0 },
        { label: "家庭中医馆", value: 1 },
        { label: "中医智库", value: 2 },
      ],
      platform_type1: 1,
      platform_typeData: "全部",
      enable: [
        { label: "生效", value: 0 },
        { label: "未生效", value: 1 },
        { label: "全部", value: 2 },
      ],
      enableData: "全部",
      location_type: 2,
      topics_type: [],
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      loading: false,
      imageUrl: "",
      multipleSelection: [],
      delList: [],
      editVisible: false,
      is_add: false,
      uploading: false,
      form: {},
      submit_obj: {},
      rules: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        platform_type: [
          { required: true, message: "请选择所属项目", trigger: "blur" },
        ],
        img_path: [
          { required: true, message: "请上传广告图片", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请填写广告显示时间", trigger: "blur" },
        ],
        date: [
          { required: true, message: "请选择广告生效时间", trigger: "blur" },
        ],
      },
      idx: -1,
      id: -1,
      type: true,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    goDate() {
      console.log(this.form.date, "this.form.date");
      this.form.start_time = this.form.date[0] / 1000;
      this.form.end_time = this.form.date[1] / 1000;
      console.log(this.form.start_time, "form.start_time");
      console.log(this.form.end_time, "form.end_time");
    },
    // 搜索
    searchBtn() {
      console.log(this.searchDate, "searchDate");
      if (this.searchDate.length != 0) {
        this.start_time = this.searchDate[0] / 1000;
        this.end_time = this.searchDate[1] / 1000;
      }
      let that = this;
      let params = {
        keyword: that.searchTitle,
        start_time: that.start_time,
        end_time: that.end_time,
        platform_type: that.searchPlatform_type,
        enable: that.searchEnable,
        page: that.currentPage,
        page_size: that.page_size,
      };
      http.get("admin/ads", { params: params }).then(function(res) {
        that.tableData = res.data.data.items;
        that.currentPage = 1;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    locationTypes(id) {
      var item = _.filter(this.location_types, function(selector) {
        return selector.value == id;
      })[0];
      if (item) {
        return item["label"];
      } else {
        return "";
      }
    },
    topicsType(id) {
      var item = _.filter(this.topics_type, function(selector) {
        return selector.term_id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        platform_type: 0,
        enable: 2,
        page: that.currentPage,
        page_size: that.page_size,
      };
      http.get("admin/ads", { params: params }).then(function(res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.items;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    //选择
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    //启用操作
    enableEdit(row) {
      // 二次确认删除
      let that = this;
      let params = {
        title: row.title,
        start_time: row.start_time,
        end_time: row.end_time,
        enable: row.enable,
        img_path: row.img_path,
        link_url: row.link_url,
        platform_type: row.platform_type,
        duration: row.duration,
      };
      if (row.enable == 1) {
        params["enable"] = 0;
        that
          .$confirm("是否关闭启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/ads/" + row.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("关闭成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        params["enable"] = 1;
        that
          .$confirm("是否启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/ads/" + row.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("启用成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 图片上传
    beforeAvatarUpload(file) {
      console.log(file, "file");
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "advertise/" + that.form.platform_type);
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl =
              "advertise/" + that.form.platform_type + "/" + filename;
            that.form.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/ads/" + row.id).then(function(res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onInput() {
      this.$forceUpdate();
    },
    // 编辑操作
    handleEdit(row) {
      this.form = {
        id: row.id,
        title: row.title,
        start_time: row.start_time,
        end_time: row.end_time,
        enable: row.enable,
        img_path: row.img_url,
        link_url: row.link_url,
        platform_type: row.platform_type,
        duration: row.duration,
      };
      this.$set(this.form, "date", [this.form .begin_time, this.form .end_time]);
      this.imageUrl = row.img_path;
      this.editVisible = true;
    },
    //新增操作
    addEdit() {
      this.form = {
        title: "",
        platform_type: 0,
        link_url: "",
        img_path: "",
        duration: 5,
        start_time: "",
        end_time: "",
      };
      this.is_add = true;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            link_url: that.form.link_url,
            img_path: that.imageUrl,
            platform_type: that.form.platform_type,
            duration: that.form.duration,
            title: that.form.title,
            start_time: that.form.start_time,
            end_time: that.form.end_time,
          };
          if (that.is_add) {
            http.post("admin/ads", params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success(`新增成功`);
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          } else {
            http.put("admin/ads/" + that.form.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success(`修改成功`);
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          }
          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
  height: 180px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  display: block;
  max-width: 100%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
